module.exports = __webpack_public_path__ + "img/growcify-app-banner-5.2a180c3b.png";